import React from "react";

const ContactForm = () => {
  return (
    <div>
      <input
        type="text"
        className="form-control mb-3"
        name="name"
        placeholder="Your Name*"
        required
      />
      <input
        type="text"
        className="form-control mb-3"
        name="email"
        placeholder="Your Email*"
        required
      />
      <textarea
        name="message"
        className="w-100 form-control mb-3"
        cols="30"
        rows="10"
        placeholder="Your Message ..."
      ></textarea>
      <button className="btn site_btn text-white" name="send">
        Send Message
      </button>
    </div>
  );
};

export default ContactForm;
